import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import { Job } from "../../../../../../../models/job";
import Modal from "../../../../../../../components/Generic/Modal";
import Quotes from "../../../../../Moving/Quote";
import QuoteMaintenance from "../../../../../Moving/Quote/Maintenance";
import useStyles from "./styles";

type Props = {
  viewOnly?: boolean;
  agentId?: number;
};

const Quote = (props: Props) => {
  const { viewOnly, agentId } = props;

  const classes = useStyles();

  const [modalQuoteMaintenanceIsOpen, setModalQuoteMaintenanceIsOpen] = useState<boolean>(false);

  const [quoteSelected, setQuoteSelected] = useState<Job>();

  const { t: translate } = useTranslation();

  const editQuote = (id: number, quote: Job) => {
    setModalQuoteMaintenanceIsOpen(true);
    setQuoteSelected(quote);
  };

  return (
    <>
      <Modal
        title={translate("quote")}
        open={modalQuoteMaintenanceIsOpen}
        handleClose={() => {
          setModalQuoteMaintenanceIsOpen(false);
          setQuoteSelected(undefined);
        }}
        className={classes.modal}
      >
        <QuoteMaintenance
          onCancel={() => {
            setModalQuoteMaintenanceIsOpen(false);
            setQuoteSelected(undefined);
          }}
          onSave={() => {
            setModalQuoteMaintenanceIsOpen(false);
            setQuoteSelected(undefined);
          }}
          className={classes.quote}
          showTitle={false}
          jobId={quoteSelected?.id}
        />
      </Modal>
      <Quotes
        className={classes.quoteList}
        classNameContent={classes.quoteContent}
        viewOnly={viewOnly}
        showTitle={false}
        handleNewRecord={() => setModalQuoteMaintenanceIsOpen(true)}
        handleEdit={editQuote}
        orderByGeneralActions={!viewOnly ? ["handleNewRecord"] : []}
        customFilter={{ agentId }}
      />
    </>
  );
};

export default Quote;
